import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { MaintenanceService } from './core/services/maintenance.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      // Re-clicking the current route (e.g. "New Publication") re-runs guards,
      // so the wizard can prompt to save/discard before restarting.
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideHttpClient(withInterceptors([apiInterceptor])),
    // Resolve the maintenance flag before first render so the gate shows
    // immediately with no flash of the real app. Fails open (see the service).
    provideAppInitializer(() => inject(MaintenanceService).check()),
  ],
};
